let ymapsPromise: Promise<any> | null = null;

export function loadYMaps(apiKey: string, lang = "ru_RU"): Promise<any> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Yandex Maps can be loaded only in browser"));
  }

  if (ymapsPromise) return ymapsPromise;

  ymapsPromise = new Promise((resolve, reject) => {
    const w = window as any;

    // Уже загружено — просто ждём готовности
    if (w.ymaps && typeof w.ymaps.ready === "function") {
      w.ymaps.ready(() => resolve(w.ymaps));
      return;
    }

    // Скрипт уже вставлен — подписываемся на load/error
    const existing = document.getElementById("ymaps-script") as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener("load", () => (w.ymaps?.ready ? w.ymaps.ready(() => resolve(w.ymaps)) : reject(new Error("ymaps missing"))));
      existing.addEventListener("error", () => reject(new Error("Failed to load Yandex Maps script")));
      return;
    }

    const script = document.createElement("script");
    script.id = "ymaps-script";
    script.type = "text/javascript";
    script.async = true;

    // Официальный формат подключения: 2.1 + apikey + lang [1](https://yandex.com/maps-api/docs/js-api/dg/concepts/load.html)[2](https://yandex.com/maps-api/docs/js-api/quickstart.html)
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${encodeURIComponent(apiKey)}&lang=${encodeURIComponent(lang)}`;

    script.onload = () => {
      if (!w.ymaps?.ready) return reject(new Error("ymaps is not available after script load"));
      // Инициализацию делаем через ymaps.ready [2](https://yandex.com/maps-api/docs/js-api/quickstart.html)[1](https://yandex.com/maps-api/docs/js-api/dg/concepts/load.html)
      w.ymaps.ready(() => resolve(w.ymaps));
    };

    script.onerror = () => reject(new Error("Failed to load Yandex Maps script"));
    document.head.appendChild(script);
  });

  return ymapsPromise;
}